<form novalidate (ngSubmit)="createToken()" [formGroup]="stripeTest" style="width: 50%;">
    <input type="text" formControlName="name" placeholder="Jane Doe">
    <ngx-stripe-card
      [options]="cardOptions"
      [elementsOptions]="elementsOptions"
    ></ngx-stripe-card>
    <button type="submit">
      CREATE TOKEN
    </button>
  </form>